// Defers inserting <shopify-account> into the DOM until the user actually
// shows intent to use it (hover, keyboard focus, or touch), instead of on
// every page load. Shopify's own account.js self-initializes the instant the
// element connects (dynamic-imports account-dialog/observe-logger chunks and
// fires a shop.app pre-auth handshake), so this only defers *that* cost —
// nothing about the button's look or its own click-through behavior changes.
(function () {
  var containers = document.querySelectorAll('[data-account-lazy]');

  containers.forEach(function (container) {
    var placeholder = container.querySelector('[data-account-placeholder]');
    var template = container.querySelector('[data-account-template]');
    if (!placeholder || !template) return;

    var activated = false;

    function focusRealTrigger(accountEl) {
      if (!accountEl || typeof customElements === 'undefined') return;
      customElements.whenDefined('shopify-account').then(function () {
        requestAnimationFrame(function () {
          var root = accountEl.shadowRoot;
          var internalTrigger = root && root.querySelector('button');
          (internalTrigger || accountEl).focus();
        });
      });
    }

    function activate(viaKeyboard) {
      if (activated) return;
      activated = true;

      var fragment = template.content.cloneNode(true);
      var accountEl = fragment.querySelector('shopify-account');

      placeholder.replaceWith(fragment);
      template.remove();

      if (viaKeyboard) focusRealTrigger(accountEl);
    }

    placeholder.addEventListener('pointerenter', function () { activate(false); }, { once: true });
    placeholder.addEventListener('touchstart', function () { activate(false); }, { once: true, passive: true });
    placeholder.addEventListener('focus', function () { activate(true); }, { once: true });
  });
})();
